import React, {useState} from 'react';
import {PersonLineStyle, PersonNameCell, PersonDayCell, PersonDayCellInner, TimeRegistrationNameCell, TimesheetsIconWrapper} from './timesheets_team_page_styled';
import {workingHourForTheDay, getHolidaysOfTheDay, getEmailIcon} from '../../../forecast-app/my-work-tab/my-timesheets-page/timesheets_person_data';
import {separateWorkingTimeAndTimeOff, getTimeRegistrationsOfTheDay, findSameTimeRegistrations} from '../../../forecast-app/my-work-tab/my-timesheets-page/timesheets_time_registrations';
import Person from '../../../forecast-app/shared/components/person/person';
import {profilePicSrc, BUTTON_COLOR, BUTTON_STYLE} from '../../../constants';
import {CSS_CONSTANTS} from '../../../css_variables';
import Util from '../../../forecast-app/shared/util/util';
import CheckmarkIcon from '../../../images/checkmark_icon';
import {ProjectIndicator} from '../../../forecast-app/shared/components/project-indicator/project_group_indicator';
import Moment from 'moment';
import {getNavigationString} from '../../../forecast-app/shared/components/project-indicator/project_group_indicator';
import {showModal, MODAL_TYPE} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import SendTimeRegEmailMutation from '../../../mutations/send_time_reg_email_mutation';
import TooltipContainer from '../../../forecast-app/shared/components/tooltips/tooltip_container';
import {CaretIcon, TimesheetsIcon} from 'web-components';

export const PersonLine = ({id, viewer, intl, history, lastOne, person, firstDayOfWeek, timeRegistrations, parentId, timeRegs, lockedDate}) => {
	const timeRegistrations_cpy = person ? [...timeRegs] : []; // TODO SORT AND GROUP
	const [expanded, setExpanded] = useState();
	if (person && !person.active && timeRegistrations_cpy.length === 0) {
		return <></>;
	}

	let tr = [];

	timeRegistrations_cpy.forEach(t => {
		if (t) {
			tr.push(findSameTimeRegistrations(timeRegistrations_cpy, t));
		}
	});

	const sortTimeReg = (t1, t2) => {
		const time1 = t1[0].node;
		const time2 = t2[0].node;
		const projectId1 = parseInt(time1.project ? time1.project.companyProjectId : time1.task ? time1.task.project.companyProjectId : 111111);
		const projectId2 = parseInt(time2.project ? time2.project.companyProjectId : time2.task ? time2.task.project.companyProjectId : 111111);

		//Same project ?
		if (projectId1 === projectId2) {
			// Same task ?
			const time1TaskName = time1.task ? time1.task.name : '';
			const time2TaskName = time2.task ? time2.task.name : '';

			if (time1TaskName === time2TaskName) {
				//idle times, time off
				const internalTime1 = time1.idleTime ? (!time1.idleTime.isInternalTime ? time1.idleTime.name : '') : '';
				const internalTime2 = time2.idleTime ? (!time2.idleTime.isInternalTime ? time2.idleTime.name : '') : '';
				if (internalTime1 === internalTime2) {
					//idle times, internal time
					const timeOff1 = time1.idleTime ? time1.idleTime.name : '';
					const timeOff2 = time2.idleTime ? time2.idleTime.name : '';
					return timeOff1 > timeOff2;
				}
				return internalTime1 > internalTime2 ? 1 : -1;
			}

			return time1TaskName > time2TaskName ? 1 : -1;
		}
		return projectId1 - projectId2;
	};

	const sendMail = person => {
		Util.CommitMutation(SendTimeRegEmailMutation, {
			receiverId: person.id,
			dateRange: firstDayOfWeek.clone().startOf('w').format('DD MMMM') + ' - ' + firstDayOfWeek.clone().endOf('w').format('DD MMMM YYYY'),
		});
	};

	const openSendMailModal = (e, person) => {
		e.stopPropagation();
		showModal({
			type: MODAL_TYPE.GENERIC,
			headerText: intl.formatMessage({id: 'timesheet.reminder_modal_header'}),
			content: <div className={'body-container'}>{intl.formatMessage({id: 'timesheet.reminder_modal_body'}, {person: person.firstName + ' ' + person.lastName})}</div>,
			className: 'default-warning-modal',
			buttons: [
				{
					text: intl.formatMessage({id: 'common.cancel'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.WHITE,
				},
				{
					text: intl.formatMessage({id: 'common.send'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.GREEN,
					callback: sendMail.bind(this, person),
				},
			],
		});
	};

	const timesheetsRedirect = e => {
		e.stopPropagation();
		const firstDayOfWeekFormatted = firstDayOfWeek.clone().format('YYYY-MM-DD');
		window.open(`/timesheets?personId=${person.id}&date=${firstDayOfWeekFormatted}`);
	};

	var filtered = expanded ? tr.filter(t => t !== null).sort(sortTimeReg) : tr;
	const timeRegistration = timeRegistrations ? timeRegistrations[0].node : null;

	const timeRegClasName = timeRegistrations ? ' time-reg-cell' : '';
	let totalWeekTime = 0; //calulated from the total of each days
	let totalWeekTimeHoliday = 0; //needed to remove the holidays form the total of the week
	const {formatMessage} = intl;

	const lockedWeek = lockedDate && lockedDate.isSameOrAfter(firstDayOfWeek.clone().endOf('week'), 'd');

	return (
		<>
			<PersonLineStyle
				data-userpilot={id === 0 ? 'timesheets-team-first-person' : ''}
				id={timeRegistration ? `person-${parentId}-time-reg-row-${id}` : `person-row-${id}`}
				className={timeRegistrations_cpy.length > 0 ? ' expandable' : '' + (timeRegistrations ? ' time-reg-row' : '') + (id === 0 ? ' first-time-reg-row' : lastOne ? ' last-time-reg-row' : '')}
				onClick={timeRegistrations_cpy.length > 0 ? () => setExpanded(!expanded) : null}
			>
				{person ? (
					<PersonNameCell>
						<div className={'person-name-cell-inner'}>
							<div className="arrow" data-userpilot="timesheets-team-arrow">
								{timeRegistrations_cpy.length > 0 ? <CaretIcon color={CSS_CONSTANTS.v2_text_gray} direction={expanded ? CaretIcon.DIRECTION.UP : CaretIcon.DIRECTION.DOWN} /> : <div className="empty-arrow"></div>}
							</div>
							<div className="profile-picture">
								<Person name={`${person.firstName} ${person.lastName}`} showName={false} showRole={false} imageSize="new-ui-dropdown" imageSrc={person.profilePictureId ? profilePicSrc(person.profilePictureId) : null} />
							</div>
							<div className="name-and-role">
								<div className="name">{person.firstName + ' ' + person.lastName}</div>
								<div className="role" title={person.role ? person.role.name : ' '}>
									{person.role ? person.role.name : ' '}
								</div>
							</div>
							{!person.active ? <div className={'deactivated'}>{formatMessage({id: 'team.deactivated-group-title'})}</div> : null}
							{person.active ? (
								<TooltipContainer infoText={intl.formatMessage({id: 'timesheet.go_to_persons_timesheet'}, {firstName: person.firstName})} growable>
									<TimesheetsIconWrapper>
										<TimesheetsIcon onClick={e => timesheetsRedirect(e, false)}></TimesheetsIcon>
									</TimesheetsIconWrapper>
								</TooltipContainer>
							) : null}
						</div>
					</PersonNameCell>
				) : (
					//timeRegistration
					<TimeRegistrationNameCell className={timeRegClasName}>
						{(timeRegistration.task && !timeRegistration.task.project.fullAccessToProject) || (timeRegistration.project && !timeRegistration.project.fullAccessToProject) ? (
							<div className="name-and-type">
								<div className={'name no-access'}>
									<ProjectIndicator project={timeRegistration.project || timeRegistration.task.project} clearSubPath={true} disableLink noTitle></ProjectIndicator>
									<div className={'time-name'}>{intl.formatMessage({id: 'timesheets.no_access'})}</div>
								</div>
							</div>
						) : timeRegistration.task ? (
							<div className="name-and-type">
								<div className={'name task'}>
									<TooltipContainer infoText={intl.formatMessage({id: 'common.go_to_project'})}>
										<ProjectIndicator project={timeRegistration.task.project} clearSubPath={true}></ProjectIndicator>
									</TooltipContainer>
									<div className={'time-name'} title={timeRegistration.task.name} onClick={() => Util.showTaskModal(timeRegistration.task.companyTaskId, history)}>
										{timeRegistration.task.name}
									</div>
								</div>
								<div className={'type'}>{formatMessage({id: 'common.task'})}</div>
							</div>
						) : timeRegistration.project ? (
							<div className="name-and-type">
								<div className={'name project'}>
									<TooltipContainer infoText={intl.formatMessage({id: 'common.go_to_project'})} growable>
										<ProjectIndicator project={timeRegistration.project} clearSubPath={true}></ProjectIndicator>
										<a href={getNavigationString(timeRegistration.project, true)} title={timeRegistration.project.name} className={'time-name'} tabIndex="0">
											{timeRegistration.project.name}
										</a>
									</TooltipContainer>
								</div>
								<div className={'type'}>{formatMessage({id: 'common.project'})}</div>
							</div>
						) : (
							<div className="name-and-type">
								<div className={'name idle-time'} title={timeRegistration.idleTime ? timeRegistration.idleTime.name : ''}>
									{timeRegistration.idleTime ? timeRegistration.idleTime.name : ''}
								</div>
								<div className={'type'}>{timeRegistration.idleTime && timeRegistration.idleTime.isInternalTime ? formatMessage({id: 'common.internal_time'}) : formatMessage({id: 'common.time_off'})}</div>
							</div>
						)}
					</TimeRegistrationNameCell>
				)}
				{Array(7)
					.fill(0)
					.map((n, i) => {
						const day = firstDayOfWeek.clone().add(i, 'day');

						const today = Moment(day).isSame(Moment(), 'day');

						const lockedDay = lockedDate && lockedDate.isSameOrAfter(day, 'd');

						let workingHours = 0;
						let totalTime = 0;
						let timeWorked;
						let timeRegsOfTheDay;
						let numberOfTimeRegistrations = 0;
						if (person) {
							workingHours = workingHourForTheDay(person, day);
							timeRegsOfTheDay = getTimeRegistrationsOfTheDay(day, timeRegs);
							numberOfTimeRegistrations = timeRegsOfTheDay.length;
							timeWorked = separateWorkingTimeAndTimeOff(timeRegsOfTheDay);
							totalTime = timeWorked.timeOff + timeWorked.workingTime;
						} else {
							totalTime = timeRegistrations.reduce((sum, t) => {
								if (t.node.day === day.date()) {
									numberOfTimeRegistrations++;
									return t.node.minutesRegistered + sum;
								}
								return sum;
							}, 0);

							//find all fron today and
						}
						const holidayOfTheDay = person ? getHolidaysOfTheDay(person, day) : [];

						const nonWorkingDay = person ? holidayOfTheDay.length > 0 || workingHours === 0 : false;

						//to avoid recalculation of the week total
						totalWeekTime += totalTime;
						totalWeekTimeHoliday += holidayOfTheDay.length > 0 ? workingHours : 0;

						//the max is used for the extra time, it would stay 0 for the time registration rows
						const percentageTimeOff = workingHours > 0 ? (timeWorked.timeOff * 100) / Math.max(workingHours, totalTime) : 0;
						const percentageWorked = workingHours > 0 ? (timeWorked.workingTime * 100) / Math.max(workingHours, totalTime) : 0;

						const totalDailyTimeInHours = Util.convertMinutesToFullHour(totalTime, intl, true);

						return (
							<PersonDayCell day={i} className={timeRegClasName + (today ? ' today' : '') + (nonWorkingDay ? ' non-working-day' : '')}>
								<PersonDayCellInner timeWorkedHeight={percentageWorked} timeOffHeight={percentageTimeOff} whiteSpaceHeight={100 - (percentageWorked + percentageTimeOff)}>
									{person && !nonWorkingDay ? (
										<div className={'background'}>
											<div className={'white-space-background'}></div>
											<div className={'time-worked-background'}></div>
											<div className={'time-off-background'}></div>
										</div>
									) : null}
									<div className={'time-worked' + timeRegClasName}>
										{person && totalTime >= workingHours && !nonWorkingDay ? <CheckmarkIcon locked={lockedDay} /> : ''}
										<div className={'total' + (lockedDay && ' locked')}>{numberOfTimeRegistrations > 0 ? totalDailyTimeInHours : ''}</div>
									</div>
								</PersonDayCellInner>
							</PersonDayCell>
						);
					})}
				<PersonDayCell className={timeRegClasName}>
					<PersonDayCellInner>
						<div className={'time-worked'}>
							{person ? getEmailIcon(firstDayOfWeek.clone().endOf('week'), lockedDate, person, totalWeekTime + totalWeekTimeHoliday, openSendMailModal, intl) : null}
							<div className={'total' + (lockedWeek && ' locked')}>{Util.convertMinutesToFullHour(totalWeekTime, intl, true)}</div>
						</div>
					</PersonDayCellInner>
				</PersonDayCell>
			</PersonLineStyle>
			{expanded
				? filtered.map((timeReg, index) => {
						//to reduce calculations the registration in the groupe are set to null in the timeRegistrations_cpy
						return (
							<PersonLine
								key={index}
								id={index}
								parentId={id}
								lastOne={index === filtered.length - 1}
								viewer={viewer}
								intl={intl}
								timeRegistrations={timeReg}
								firstDayOfWeek={firstDayOfWeek}
								lockedDate={lockedDate}
								history={history}
							></PersonLine>
						);
				  })
				: null}
		</>
	);
};
